import React from 'react';
import { LOCAL_EN } from '@/config';
import { Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { Card } from '../Card';
import { CopyIcon, GiftOutlineIcon } from '../Icons';

const { Text } = Typography;

interface FreeOrdersProps {
  referText: string;
  mgCode: string;
}

const FreeOrders: React.FC<FreeOrdersProps> = ({ referText, mgCode }) => {
  const { i18n, t } = useTranslation();

  return (
    <Card>
      <Flex
        justify='space-between'
        className={`pl-[10px] ${i18n.language === LOCAL_EN ? 'pl-[10px]' : 'pr-[10px] pl-0'}`}
      >
        <Flex>
          <Flex className='w-[43px] p-[10px] h-[43px] rounded-full bg-customGrayShade2 flex items-center justify-center'>
            <GiftOutlineIcon width={24} height={24} />
          </Flex>
          <Flex vertical className='mx-[14px] gap-y-1'>
            <Text className=' capitalize font-bold text-base leading-[19.2px] tracking-[-0.32px] text-customTunaPrimary'>
              {t('free_orders')}
            </Text>
            <Text className=' font-normal text-sm leading-[16.8px] tracking-[-.32px] text-customGrayShade5'>
              {referText}
            </Text>
          </Flex>
        </Flex>
        <Flex
          className={`flex justify-end items-center ${i18n.language === LOCAL_EN ? 'pl-[19px]' : 'pr-[19px]'} gap-x-3 h-[40px] rounded-[100px] border border-dashed border-customGrayShade4`}
        >
          <Text className=' font-bold text-sm leading-[16.8px] tracking-[-.32px] text-customTunaPrimary'>
            {mgCode}
          </Text>
          <Flex className='w-8 h-8 flex justify-center items-center rounded-full bg-customYellowPrimary'>
            <CopyIcon width={16} height={16} />
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};

export default FreeOrders;
